angular.module('bmsApp.trugreen.quote').factory('TGTreatmentSvc', function ($rootScope,
																		  $modal,
																		  notify,
																		  CRUDSvc) {

	return {
		options: function (params) {
			return CRUDSvc.get('api/trugreen/treatmentsList/options', params);
		},
		getTreatmentPrice: function (treatmentId, lawnArea, customerId) {
			var params = {
				treatmentId: treatmentId,
				lawnArea: lawnArea,
				customerId: customerId
			};
			return CRUDSvc.get('api/trugreen/treatmentsList/getTreatmentPrice', params);
		},
		showJobTreatmentModal: function (tgJob, tgJobTreatment) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/trugreen/quote/templates/QuoteTreatmentModal.html',
				controller: 'TGQuoteTreatmentModalCtrl',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					tgJob: function () {
						return angular.copy(tgJob);
					},
					tgJobTreatment: function () {
						return angular.copy(tgJobTreatment);
					}
				}
			});

			return modalInstance.result;
		},
		getTreatmentAreasList: function (tgJobTreatment) {
			var labels = [];
			if (tgJobTreatment.lawn_all) {
				labels.push('All');
			}
			else {
				if (tgJobTreatment.lawn_front) {
					labels.push('Front ' + tgJobTreatment.lawn_front_size + 'm<sup>2</sup>');
				}
				if (tgJobTreatment.lawn_rear) {
					labels.push('Rear ' + tgJobTreatment.lawn_rear_size + 'm<sup>2</sup>');
				}
				if (tgJobTreatment.lawn_side) {
					labels.push('Side ' + tgJobTreatment.lawn_side_size + 'm<sup>2</sup>');
				}
				if (tgJobTreatment.lawn_other) {
					labels.push('Other ' + tgJobTreatment.lawn_other_size + 'm<sup>2</sup>');
				}
			}
			return labels.join(', ');
		}
	};

});
